import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'secondary' | 'ghost';
  style?: React.CSSProperties;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  className = '',
  disabled = false,
  type = 'button',
  size = 'md',
  variant = 'secondary',
  style
}) => {
  const baseClasses = 'flex items-center justify-center transition-colors duration-200 rounded-lg button-outline focus:outline-none focus:ring-0';
  
  const sizeClasses = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-12 h-12 text-lg'
  };
  
  const variantClasses = {
    primary: 'text-text bg-accent hover:bg-accent/80 active:bg-accent/90',
    secondary: 'text-textSecondary hover:text-text hover:bg-hover active:bg-hover/80',
    ghost: 'text-textSecondary hover:text-text hover:bg-hover/50 active:bg-hover'
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      style={style}
    >
      {children}
    </button>
  );
}; 